module.exports = __webpack_public_path__ + "media/src/images/speech-bubble-55228d21283957f427bafbe3aa16cb9a.svg";